module.exports = __webpack_public_path__ + "img/logo.d917d6b8.svg";